var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$wait.is("loading_resource")
    ? _c(
        "div",
        { staticClass: "loading" },
        [_c("Spinner", { attrs: { height: 40, width: 40 } })],
        1
      )
    : _vm.items && _vm.items.length > 0
    ? _c(
        "div",
        { staticClass: "user-feed" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c("UserSearchResult", {
              key: `sector-post-${item.id}`,
              attrs: { resource: item },
            })
          }),
          _vm._v(" "),
          _c("Pagination", {
            ref: "pagination",
            on: { "vuetable-pagination:change-page": _vm.onChangePage },
          }),
        ],
        2
      )
    : _c("div", { staticClass: "no-results" }, [_vm._v("No results")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }